import { withInstall, withNoopInstall } from '@bigin/utils'

import Skeleton from './src/skeleton.vue'
import SkeletonItem from './src/skeleton-item.vue'

export const BSkeleton = withInstall(Skeleton, {
  SkeletonItem,
})
export const BSkeletonItem = withNoopInstall(SkeletonItem)
export default BSkeleton

export * from './src/skeleton'
export * from './src/skeleton-item'
